/* eslint-disable no-unused-vars */
import integrationService from "@/services/integration";
import store from "@/state/store";
var CryptoJS = require("crypto-js");
var CryptoJSAesJson = {
  stringify: function (cipherParams) {
    var j = {
      ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)
    };
    if (cipherParams.iv) j.iv = cipherParams.iv.toString();
    if (cipherParams.salt) j.s = cipherParams.salt.toString();
    return JSON.stringify(j);
  },
  parse: function (jsonStr) {
    var j = JSON.parse(jsonStr);
    var cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(j.ct),
    });
    if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
    if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
    return cipherParams;
  },
};

import router from "../../router/index";

export const state = {
  directoryList: [],
  gridIntegrationData: null,
  createIntegration: {},
  intgData: {},
  intgDataMapping: null,
  intgStatus: null,
  responseErrors: [],
  errMsg: "",
  loading: false,
  syncDestroyed: true,
  noGroups: false,
  directoryConfigData: {},
  createdIntgId: null,
  syncLoading: false,
  syncTextMessage: "",
  syncStatus: "processing",
  syncTextFullMessage: '',
  migrateTextMessage: "",
  migrateStatus: "idle",
  migrateTextFullMessage: '',
  syncedUsers: [],
  syncedUsersCount: null,
  validUsers: [],
  validUsersCount: null,
  usersWithErrs: [],
  usersWithErrsCount: null,
  usersWithDuplicates: [],
  usersWithDuplicatesCount: null,
  modalState: false,
  isEditMode: false,
  isFromView: false,
  isFromBack: false,
  isReAuth: false,
  syncId: '',
  syncLogs: [],
  syncAttendanceCodes: [],
  integrationUserTypes: [],
  decryptedEmail: '',
  wondeHaveTokenValue: 0,
  siteAreas: [{
    value: "",
    text: "Select Area"
  }],
  selectedArea: null,
  isExtraScenario: false,
  dirAreas: [],
  intgName: "",
  wondeIntegrations : [],
  integrationScans: [],
  integrationAttendanceCodes: [],
  roles: []
};

export const actions = {
  setResponseErrors({ commit }, payload) {
    commit("setResponseErrors", payload);
  },
  fetchDirectoryList({
    commit,
    dispatch
  }, payload) {
    // dispatch("resetIntgData");
    commit("setResponseErrors", null);
    return new Promise((resolve, reject) => {
      integrationService
        .getAllDirectories()
        .then((data) => {
          resolve(data);
          commit("setDirectoryList", data);
          if (payload.fromStore) {
            const directory = data.find(item => item.id == payload.id);
            commit("modal/setData", directory, {
              root: true
            });
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  fetchGridIntegrationData({
    commit,
    dispatch
  }) {
    // dispatch("resetIntgData");
    return new Promise((resolve, reject) => {
      integrationService
        .getGridInetgrationsData()
        .then((data) => {
          resolve(data);
          commit("setGridData", data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getIntegration({
    commit,
    dispatch
  }, payload) {
    return new Promise((resolve, reject) => {
      integrationService
        .getIntegration(payload.id)
        .then((data) => {
          console.log('ddd', data);
          resolve(data);
          commit("setIntegId", payload.id);
          commit("setIntgData", data);
          if (payload.fromAllTable) {
            let obj;
            switch (data.dir_code) {
              case "googleAD":
                obj = {
                  token: data.configs[0].value
                };
                break;
              case "azureAD":
                obj = {
                  tenant_id: data.configs[0].value,
                  client_id: data.configs[1].value,
                  client_secret: data.configs[2].value
                };
                break;
              case "paxton":
                obj = {
                  username: data.configs[0].value,
                  password: data.configs[1].value,
                  clientId: data.configs[2].value,
                  serverUrl: data.configs[3].value
                };
                break;
                case "wonde":
                  obj = {
                    schoolId: data.configs[0].value,
                    token: data.configs[1].value,
                  };
                  break;
              default:
                break;
            }
            dispatch("createIntegration", {
              obj,
              directory_type: data.dir_code,
              fromStore: true,
              continue: payload.continue
            });
            dispatch("fetchDirectoryList", {
              fromStore: true,
              id: data.dir_id
            });
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  async awaitIntegrationWithMapping({
    dispatch
  }, payload) {
    await dispatch("getIntegrationWithMapping", payload);
  },

  async getIntegrationWithMapping({
    commit,
    dispatch
  }, payload) {
    await dispatch("resetIntgData");
    return new Promise((resolve, reject) => {
      integrationService
        .getIntegrationWithMapping(payload.id)
        .then((data) => {
          console.log('ddd', data);
          resolve(data);
          commit("setIntegId", payload.id);
          commit("setIntgDataMapping", data);
          commit("setIntgStatus", data.status);
          if (store.getters["integration/getFromView"]) {
            // dispatch("getIntegrationStat", payload.id);
          } else {
            dispatch("fetchTempUsersWithDuplicates", payload.id);
            dispatch("fetchTempUsersWithErrors", payload.id);
            dispatch("fetchValidTempUsers", payload.id);
          }
          // if (payload.redirect) router.push("/view-integration/" + payload.id + "/" + data.name);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getIntegrationStat({
    commit,
    dispatch
  }, payload) {
    return new Promise((resolve, reject) => {
      integrationService
        .getIntegrationStat(payload)
        .then((data) => {
          resolve(data);
          console.log('stat', data);
          // commit("setIntgStatus", data.dir_int_status);

          commit("setUsersWithErrsCount", data.errors);
          commit("setSyncedUsersCount", data.imported);
          commit("setUsersWithDuplicatesCount", data.duplicates);
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getIntegrationStatus({
    commit,
    dispatch
  }, payload) {
    return new Promise((resolve, reject) => {
      integrationService
        .getIntegrationStatus(payload)
        .then((data) => {
          resolve(data);
          commit("setIntgStatus", data.dir_int_status);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  changeIntegrationStatus({
    commit
  }, payload) {
    commit("setLoading", true);
    commit("setIntgStatus", "");
    return new Promise((resolve, reject) => {
      integrationService
        .changeIntegrationStatus(payload.integId, payload.status)
        .then((data) => {
          resolve(data);
          console.log('change', data, payload);
          commit("setLoading", false);
          commit("setIntgStatus", data.status);
          // dispatch("resetIntgData", payload);
          // dispatch("fetchTempUsersWithErrors", payload);
          // dispatch("fetchValidTempUsers", payload);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  fetchIntegrationUsersTypes({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      integrationService
        .getUsersTypes(payload)
        .then((data) => {
          resolve(data);
          commit("setIntegrationUsersTypes", data);
          console.log('usertypes', data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  fetchSelectedSitesAreas({
    commit
  }, {
    selectedSites,
    dir_id
  }) {
    if (selectedSites.length > 0) {
      return new Promise((resolve, reject) => {
        commit("setSelectedSiteAreas", []);
        integrationService
          .getSelectedSitesAreas(selectedSites, dir_id)
          .then((data) => {
            resolve(data);
            // const {
            //   cloud_areas
            // } = data
            const areas = data.data.map(area => ({
              area_id: area.id,
              area_name: area.name,
              id: area.id,
              label: area.name,
              isDisabled: area.disabled,
            }))
            commit("setSelectedSiteAreas", [{
              area_id: "",
              area_name: "Select Area",
              id: "",
              label: "Select Area"
            }, ...areas]);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
    // commit("setSelectedSiteAreas", [{
    //   value: "",
    //   text: "Select Area"
    // }]);
  },

  setReAuth({
    commit
  }, payload) {
    commit("setReAuth", payload);
    commit("setLoading", false);
  },

  async resetIntgData({
    commit
  }) {
    console.log('resetIntgData');
    await commit("setUsersWithErrs", null);
    await commit("setUsersWithErrsCount", null);
    await commit("setUsersWithDuplicates", null);
    await commit("setUsersWithDuplicatesCount", null);
    await commit("setValidUsers", null);
    await commit("setValidUsersCount", null);
    await commit("setNoGroups", null);
  },

  setEmail({
    commit
  }, payload) {
    const key = process.env.VUE_APP_PASSPORT_KEY;
    let decryptedEmail = CryptoJS.AES.decrypt(atob(payload), key, {
      format: CryptoJSAesJson,
    }).toString(CryptoJS.enc.Utf8);
    decryptedEmail = decryptedEmail.replace(/"/g, "");
    // console.log('decryptedEmail', decryptedEmail);
    commit("setDecryptedEmail", decryptedEmail);
  },

  createIntegration({
    commit,
  }, payload) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      commit("setResponseErrors", null);
      integrationService
        .createIntegration(payload)
        .then((data) => {
          resolve(data);
          if (!payload.fromStore && !payload.hideToaster) {
            if (!payload.isExtraScenario) {
              commit("setIntegId", null);
              commit("setIntgData", {});
            }
            if (!payload.hideToaster) {
              commit("setIsEdit", false);
              commit("setFromBack", false);
              commit("setFromView", false);
              this._vm.$toast.success("Authentication Success");
            }
          }
          commit("setLoading", false);
          console.log('setcreatedIntegration', data);
          commit("setcreatedIntegration", data);
          if (!payload.continue && !payload.hideToaster) router.push("/integration-settings");
        })
        .catch((err) => {
          if (payload.directory_type == "googleAD") {
            router.push("/integration");
            this._vm.$toast.error(err.data.error.message);
          }
          if (err.data.error.type === "NO_GROUP_TO_MAP") {
            commit("setLoading", false);
            commit("setNoGroups", true);
          } else {
            commit("setLoading", false);
            reject(err);
            commit("setResponseErrors", err.data.error);
          }
        });
    });
  },

  reAuthIntegration({
    commit,
    dispatch
  }, payload) {
    commit("setLoading", true);
    commit("setModalState", null);
    return new Promise((resolve, reject) => {
      commit("setResponseErrors", null);
      integrationService
        .reAuthIntegration(payload)
        .then((data) => {
          // commit("setIntegId", null);
          // commit("setIntgData", {});
          commit("setLoading", false);
          resolve(data);
          console.log('reauth', data);
          commit("setModalState", true);
          dispatch("getIntegrationStatus", payload.integId);
          this._vm.$toast.success("Re-authenticated Successfully.");
          // this.$bvModal.hide("addIntegration");
          // setTimeout(() => {
          // }, 2000);
          // commit("setcreatedIntegration", data);
          // router.push("/integration-settings");
        })
        .catch((err) => {
          commit("setLoading", false);
          reject(err);
          console.log('err', err);
          if (err.data.invalid) {
            commit("setModalState", true);
            dispatch("getIntegrationStatus", payload.integId);
          }
          commit("setResponseErrors", err.data.error);
        });
    });
  },

  createConfigData({
    commit
  }, payload) {
    commit("setConfigData", payload);
  },

  createIntegrationForPendingStatus({dispatch, commit
  }, payload) {
    return new Promise((resolve, reject) => {
      integrationService
        .deleteIntegration(payload.id)
        .then((data) => {
          resolve(data);
          dispatch("manageIntegrationSettings", payload);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  manageIntegrationSettings({
    commit,
    dispatch
  }, payload) {
    commit("setLoading", true);
    commit("setErrMsg", "");
    return new Promise((resolve, reject) => {
      integrationService
        .manageIntegrationSettings(payload)
        .then((data) => {
          console.log('manage', data, payload);
          resolve(data);
          // this._vm.$toast.success("integration settings Created");

          commit("setIntegId", data.int_id);
          router.push("/sync-status");
          dispatch("startFirstSync", data.int_id);
          dispatch("getIntegration", {
            id: data.int_id
          });
          commit("setSyncStatusText", "Integration Settings Saved");
          commit("setSyncStatusmsg", "Preparing Data");
          commit("setSyncStatusStage", "processing");
        })
        .catch((err) => {
          commit("setLoading", false);
          reject(err);
          const errMsg = err.data.errors.map(x => Object.values(x).join("\r\n")).join('\r\n');
          console.log('err', err);
          // this._vm.$toast.error(errMsg);
          commit("setErrMsg", errMsg);
        });
    });
  },

  checkNameValidation({ commit }, payload) {
    commit("setErrMsg", "");
    return new Promise((resolve, reject) => {
      integrationService
        .checkNameValidation(payload)
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
          console.log('err', err, err.data.msg);
          // this._vm.$toast.error(errMsg);
          commit("setErrMsg", err.data.msg);
        });
    });
  },
  editIntegrationSettings({
    commit,
    dispatch,
    isExtraScenario
  }, payload) {
    commit("setLoading", true);
    commit("setErrMsg", "");
    console.log('editintgsett', payload);
    return new Promise((resolve, reject) => {
      integrationService
        .editIntegrationSettings(payload.data)
        .then((data) => {
          resolve(data);
          commit("setLoading", false);
          commit("setIntegId", data.int_id);
          dispatch("getIntegration", {
            id: data.int_id
          });
          if (payload.isEdit) this._vm.$toast.success("Saved Successfully");
          if (payload.data.is_mapping_change || isExtraScenario) {
            if (!payload.isEdit) {
              // import again
              console.log('import again');
              router.push("/sync-status");
              dispatch("startFirstSync", data.int_id);
              commit("setSyncStatusText", "Integration Settings Saved");
              commit("setSyncStatusmsg", "Preparing Data");
              commit("setSyncStatusStage", "processing");
            }
          } else {
            if (!payload.isEdit) {
              // redirect to errors, duplicates, valid users
              dispatch("redirectType", {
                id: data.int_id
              });
            }
          }
        })
        .catch((err) => {
          commit("setLoading", false);
          reject(err);
          const errMsg = err.data.errors.map(x => Object.values(x).join("\r\n")).join('\r\n');
          console.log('err', err, errMsg);
          // this._vm.$toast.error(errMsg);
          commit("setErrMsg", errMsg);
        });
    });
  },

  updateIntegrationSettingsAndSync({
    commit,
    dispatch
  }, payload) {
    commit("setLoading", true);
    commit("setErrMsg", "");
    return new Promise((resolve, reject) => {
      integrationService
        .updateIntegrationSettingsAndSync(payload.data)
        .then((data) => {
          // console.log('and sync', data);
          resolve(data);
          commit("setIntegId", payload.data.id);
          dispatch("getIntegration", {
            id: payload.data.id
          });
          setTimeout(() => {
            commit("setLoading", false);
            dispatch("fetchUsersJobStatus", {
              saveAndSync: true,
              id: payload.data.id,
              name: payload.data.name
            });
            router.push("/sync-status");
          }, 2000);
          // router.push("/view-integration/" + payload.data.id + "/" + payload.data.name);
          // router.push("/sync-status");
          // commit("setSyncStatusText", "Integration Settings Saved");
          // commit("setSyncStatusmsg", "Preparing Data");
          // commit("setSyncStatusStage", "processing");
          // }
          // } else {
          // if (!payload.isEdit) {
          // redirect to view page
          // dispatch("getIntegrationWithMapping", { id: , redirect: true });
          // }
          // }


        })
        .catch((err) => {
          commit("setLoading", false);
          reject(err);
          const errMsg = err.data.errors.map(x => Object.values(x).join("\r\n")).join('\r\n');
          console.log('err', err);
          // this._vm.$toast.error(errMsg);
          commit("setErrMsg", errMsg);
        });
    });
  },

  startFirstSync({
    commit,
    dispatch
  }, payload) {
    return new Promise((resolve, reject) => {
      integrationService
        .getFirstSync(payload)
        .then((data) => {
          resolve(data);
          console.log('startFirstSync');
          commit("setLoading", false);
          setTimeout(() => {
            dispatch("fetchUsersJobStatus", {
              id: payload
            });
          }, 3000);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  startAutoSync({
    commit,
    dispatch
  }, payload) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      integrationService
        .getAutoSync(payload.id)
        .then((data) => {
          resolve(data);
          commit("setLoading", false);
          console.log('auto', payload);
          setTimeout(() => {
            router.push("/sync-status");
            dispatch("fetchUsersJobStatus", {
              id: payload.id,
              saveAndSync: true,
              name: payload.name
            });
          }, 2000);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  fetchUsersJobStatus({
    commit,
    dispatch
  }, payload) {
    commit("setSyncDestroyed", false);
    if (payload.checkDuplicate) commit("setLoading", true);
    return new Promise((resolve, reject) => {
      integrationService
        .getSyncUSerStatus(payload.id)
        .then((data) => {
          resolve(data);
          console.log('fetchUsersJobStatus', payload, data);
          const id = data.sync_status.id;
          commit("setSyncId", id);
          if (payload.continue && id != 3) {
            console.log('continue first sync');
            dispatch("startFirstSync", payload.id);
            setTimeout(() => {
              router.push("/sync-status");
            }, 1500);
          }
          //first sync statuss 
          // '0'=>'Idle',
          if (id == 0) {
            setTimeout(() => {
              dispatch("fetchUsersJobStatus", payload);
            }, 5000);
            commit("setSyncStatusText", data.sync_status.text);
            commit("setSyncStatusmsg", data.message);
            commit("setSyncStatusStage", "processing");
          } else if (id == 1) {
            //   '1'=>'Importing',
            setTimeout(() => {
              dispatch("fetchUsersJobStatus", payload);
            }, 5000);
            commit("setSyncStatusText", data.sync_status.text);
            commit("setSyncStatusmsg", data.message);
            commit("setSyncStatusStage", "processing");
          } else if (id == 11) {
            //   '1'=>'Importing Data',
            setTimeout(() => {
              dispatch("fetchUsersJobStatus", payload);
            }, 5000);
            commit("setSyncStatusText", data.sync_status.text);
            commit("setSyncStatusmsg", data.message);
            commit("setSyncStatusStage", "processing");
          } else if (id == 2) {
            // '2'=>'Validating',
            setTimeout(() => {
              dispatch("fetchUsersJobStatus", payload);
            }, 5000);
            commit("setSyncStatusText", data.sync_status.text);
            commit("setSyncStatusmsg", data.message);
            commit("setSyncStatusStage", "processing");
          } else if (id == 3 || id == 15) {
            // '3'=>'Done',
            // commit("setLoading", false);
            commit("setLoadingSync", false);
            commit("setSyncStatusText", data.sync_status.text);
            commit("setSyncStatusmsg", data.message);
            commit("setSyncStatusStage", "done");
            // dispatch("fetchValidTempUsers", payload);

            console.log('doneee', payload);

            // show duplicates || view duplicates
            if (payload.redirectToDuplicate) {
              commit("setLoading", false);
              router.push("/integration-duplicate");
            }

            // first sync
            else if (!payload.fromView && !payload.saveAndSync)
              dispatch("redirectType", {
                id: payload.id,
                duplicateChecked: payload.checkDuplicate ? true : false
              });

            // check duplicate stats
            else if (payload.fromView) {
              dispatch("getIntegrationStat", payload.id);

              // saveAndSync
            } else {
              console.log('redirecttoview');
              commit("setLoading", false);
              commit("setIntegId", payload.id);
              router.push("/view-integration/" + payload.id + "/" + payload.name);
            }

          } else if (id == 4) {
            // '4'=>'Importing Faild',
            commit("setLoadingSync", false);
            commit("setSyncStatusText", data.sync_status.text);
            commit("setSyncStatusmsg", 'Retry');
            commit("setSyncStatusStage", "failed");
          } else if (id == 6) {
            setTimeout(() => {
              dispatch("fetchUsersJobStatus", payload);
            }, 5000);
            commit("setSyncStatusText", data.sync_status.text);
            commit("setSyncStatusmsg", data.message);
            commit("setSyncStatusStage", "processing");
          } else if (id == 9) {
            // '7'=>'Authentication Failed'
            dispatch("getIntegration", {
              id: payload.id
            });
            commit("setLoadingSync", false);
            commit("setSyncStatusText", data.sync_status.text);
            commit("setSyncStatusmsg", 'Click on the "Back" button for re-authenticate');
            commit("setSyncStatusStage", "auth-failed");
            // router.push("/view-integration/" + payload.id + "/" + payload.name);
          } else if (id == 10) {
            // '10'=>'Invalid'
            dispatch("getIntegration", {
              id: payload.id
            });
            commit("setLoadingSync", false);
            commit("setSyncStatusText", data.sync_status.text);
            commit("setSyncStatusmsg", data.message);
            commit("setSyncStatusStage", "auth-failed");
            // router.push("/view-integration/" + payload.id + "/" + payload.name);
          } else {
            // '7'=>'Failed'
            commit("setLoadingSync", false);
            commit("setSyncStatusText", data.sync_status.text);
            commit("setSyncStatusmsg", 'Retry');
            commit("setSyncStatusStage", "failed");
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  fetchSyncedUsers({
    commit
  }, payload) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      integrationService
        .getAllSyncedUsers(payload)
        .then((data) => {
          resolve(data);
          // commit("setSyncStatusStage", 'done');
          // commit("setSyncedUsers", data.data);
          // commit("setSyncedUsersCount", data.totalCount);
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  fetchValidTempUsers({
    commit
  }, payload) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      integrationService
        .getValidTempUsers(payload)
        .then((data) => {
          resolve(data);
          console.log('valid users', data);
          // commit("setSyncStatusStage", 'done');
          // commit("setValidUsers", data.data);
          // commit("setValidUsersCount", data.totalCount);
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  async redirectType({
    commit,
    dispatch
  }, payload) {
    commit("setLoading", true);
    await dispatch("getIntegration", {
      id: payload.id
    });
    return new Promise((resolve, reject) => {
      integrationService.getRedirectType(payload.id).then((data) => {
          resolve(data);
          console.log('redirect', data);
          if (payload.duplicateChecked || data == 'error')
            router.push("/integration-" + data);
          else dispatch("checkDuplicate", {
            id: payload.id
          });
          // if (data == "error") dispatch("fetchTempUsersWithErrors", payload.id);
          // else if (data == "duplicate") dispatch("fetchTempUsersWithDuplicates", payload.id);
          // else if (data == "valid") dispatch("fetchValidTempUsers", payload.id);
          commit("setFromView", false);
          // setTimeout(() => { commit("setLoading", false); }, 1000);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  checkDuplicate({
    commit,
    dispatch
  }, payload) {
    // commit("setLoading", true);
    return new Promise((resolve, reject) => {
      integrationService.checkDuplicate(payload.id).then((data) => {
          resolve(data);
          // console.log('checkduplicTW', data);
          dispatch("fetchUsersJobStatus", {
            id: payload.id,
            checkDuplicate: true,
            redirectToDuplicate: payload.redirectToDuplicate ? true : false,
            fromView: payload.fromView ? true : false
          });
          // commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  redirectToIntegrationSettings({
    commit
  }) {
    commit("setFromView", false);
    commit("setFromBack", true);
    commit("setIsEdit", false);
    commit("setUsersWithErrs", null);
    commit("setUsersWithErrsCount", null);
    commit("setUsersWithDuplicates", null);
    commit("setUsersWithDuplicatesCount", null);
    // setTimeout(() => {
    router.push("/integration-settings");
    // }, 200);
  },

  async editIntegration({
    commit,
    dispatch
  }, payload) {
    commit("setIntegId", payload);
    commit("setIsEdit", true);
    commit("setFromBack", false);
    await dispatch("getIntegration", {
      id: payload,
      fromAllTable: true
    });
    await dispatch("getIntegrationStat", payload);
    // await dispatch("fetchTempUsersWithDuplicates", payload);
    // await dispatch("fetchTempUsersWithErrors", payload);
    // dispatch("redirectToIntegrationSettings");
  },

  fetchTempUsersWithErrors({
    commit
  }, payload) {
    commit("setUsersWithErrs", null);
    commit("setUsersWithErrsCount", null);
    commit("setLoading", true);
    // commit("setModalState", true);
    return new Promise((resolve, reject) => {
      integrationService.getTempUsersWithErrors(payload).then((data) => {
          resolve(data);
          console.log('fetchTempUsersWithErrors', data);
          // if (data && data.users && data.users.length > 0) router.push("/imported-with-errors");
          // commit("setSyncStatusStage", 'done');
          commit("setLoading", false);
          commit("setUsersWithErrsCount", data.totalCount);
          // commit("setUsersWithErrs", data.data);

          // setTimeout(() => {
          //   console.log('set new count');
          //   commit("setUsersWithErrsCount", 10);
          // }, 5000);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  fixTempUsersWithErrors({
    commit,
    dispatch
  }, payload) {
    dispatch("resetIntgData");
    commit("setLoading", true);
    commit("setModalState", false);
    return new Promise((resolve, reject) => {
      console.log('fixTempUsersWithErrors', payload, store.getters["integration/getFromView"]);
      integrationService.fixTempUsersWithErrors(payload).then((data) => {
          resolve(data);
          // dispatch("fetchTempUsersWithErrors", payload.user.dir_int_id);
          if (store.getters["integration/getFromView"] && data.action) {
            dispatch("updateSyncedUsers", payload.user.dir_int_id);
          }
          // setTimeout(() => {
          if (data.action && !data.is_already_fixed) this._vm.$toast.success(data.message);
          else if (!data.action) this._vm.$toast.error(data.message);
          commit("setLoading", false);
          commit("setModalState", true);
          console.log('setModalState');
          // commit("setFormErrors", []);
          // }, 5000);

        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  fetchTempUsersWithDuplicates({
    commit
  }, payload) {
    commit("setUsersWithDuplicates", null);
    commit("setUsersWithDuplicatesCount", null);
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      integrationService.getTempUsersWithDuplicates(payload).then((data) => {
          resolve(data);
          console.log('WithDuplicates', data);
          commit("setUsersWithDuplicatesCount", data.totalCount);
          // commit("setUsersWithDuplicates", data.data);
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  fixTempUsersWithDuplicates({
    commit,
    dispatch
  }, payload) {
    commit("setModalState", false);
    if (!payload.selected_user_id) {
      this._vm.$toast.error('Please select a user');
      return;
    }
    // commit("setLoading", true);
    return new Promise((resolve, reject) => {
      console.log('fixDuplicate', payload, store.getters["integration/getFromView"]);
      integrationService.fixTempUsersWithDuplicates(payload).then((data) => {
          resolve(data);
          // dispatch("fetchTempUsersWithDuplicates", payload.dir_int_id);
          if (store.getters["integration/getFromView"]) {
            dispatch("updateSyncedUsers", payload.dir_int_id);
          }

          // setTimeout(() => {
          // console.log('setloding');
          if (data.action && !data.is_already_fixed) this._vm.$toast.success(data.message);
          else if (!data.action) this._vm.$toast.error(data.message);
          // commit("setLoading", false);
          commit("setModalState", true);
          // commit("setFormDuplicates", []);
          // }, 5000);

        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  deleteIntegration({
    dispatch
  }, payload) {
    return new Promise((resolve, reject) => {
      integrationService
        .deleteIntegration(payload)
        .then((data) => {
          resolve(data);
          // commit("setIntegId", null);
          dispatch("fetchGridIntegrationData");
          this._vm.$toast.success("Integration Deleted Successfully");
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  StartSyncUsers({
    commit,
    dispatch
  }, payload) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      integrationService
        .getFirstMigration({
          id: payload.id,
          log: 1
        })
        .then((data) => {
          resolve(data);
          commit("setLoading", false);
          router.push("/sync-status");
          dispatch("fetchSyncUsersJobStatus", payload.id);
          commit("setMigrateStatusStage", "processing");
          commit("setSyncStatusStage", "finished");
          console.log('isfailed', payload.isFailed);
          // if (payload.isFailed) dispatch("redirectType", payload.id);
          // else dispatch("getIntegrationWithMapping", payload);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  updateSyncedUsers({
    commit,
    dispatch
  }, payload) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      integrationService
        .getFirstMigration({
          id: payload,
          log: 0
        })
        .then((data) => {
          resolve(data);
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  retrySync({
    commit,
    dispatch
  }, payload) {
    // commit("setLoading", true);
    console.log('syncidvv', payload);
    commit("setMigrateStatusStage", "processing");
    commit("setSyncStatusStage", "processing");
    commit("setSyncStatusText", "Preparing Data");
    commit("setSyncStatusmsg", "");
    if (payload.syncId == 4 || payload.syncId == 5 || payload.syncId == 8) {
      if (store.getters["integration/getFromView"]) {
        dispatch("startAutoSync", {
          id: payload.id,
          name: store.getters["integration/getIntgDataMapping"].name,
          redirectToView: true,
        });
      } else {
        return new Promise((resolve, reject) => {
          integrationService
            .getFirstSync(payload.id)
            .then((data) => {
              resolve(data);
              commit("setLoading", false);
              setTimeout(() => {
                dispatch("fetchUsersJobStatus", {
                  id: payload.id
                });
              }, 2000);
            })
            .catch((err) => {
              reject(err);
            });
        });
      }
    } else if (payload.syncId == 7) {
      return new Promise((resolve, reject) => {
        integrationService
          .getFirstMigration({
            id: payload.id,
            log: 1
          })
          .then((data) => {
            resolve(data);
            commit("setLoading", false);
            console.log('migrate', data);
            // router.push("/sync-status");
            console.log('isfailed', payload.isFailed);
            setTimeout(() => {
              dispatch("fetchSyncUsersJobStatus", payload.id);
            }, 2000);
            // if (payload.isFailed) dispatch("redirectType", payload.id);
            // else dispatch("getIntegrationWithMapping", payload);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  },

  fetchSyncUsersJobStatus({
    commit,
    dispatch
  }, payload) {
    commit("setSyncDestroyed", false);
    return new Promise((resolve, reject) => {
      integrationService
        .getSyncUSerStatus(payload)
        .then((data) => {
          resolve(data);
          const id = data.sync_status.id;
          commit("setSyncId", id);
          console.log('hello', id, data);

          //first sync statuss 
          // '0'=>'Idol',
          if (id == 0) {
            console.log('hidddi');
            setTimeout(() => {
              dispatch("fetchSyncUsersJobStatus", payload);
            }, 1000);
            commit("setMigrateStatusText", data.sync_status.text);
            commit("setMigrateStatusmsg", data.message);
            commit("setMigrateStatusStage", "processing");
            commit("setSyncStatusText", data.sync_status.text);
            commit("setSyncStatusmsg", data.message);
            commit("setSyncStatusStage", "processing");
          } else if (id == 1) {
            //   '1'=>'Importing',
            setTimeout(() => {
              dispatch("fetchSyncUsersJobStatus", payload);
            }, 1000);
            commit("setMigrateStatusText", data.sync_status.text);
            commit("setMigrateStatusmsg", data.message);
            commit("setMigrateStatusStage", "processing");
            commit("setSyncStatusText", data.sync_status.text);
            commit("setSyncStatusmsg", data.message);
            commit("setSyncStatusStage", "processing");
          } else if (id == 11) {
            //'1'=>'Importing Data',
            setTimeout(() => {
              dispatch("fetchSyncUsersJobStatus", payload);
            }, 1000);
            commit("setMigrateStatusText", data.sync_status.text);
            commit("setMigrateStatusmsg", data.message);
            commit("setMigrateStatusStage", "processing");
            commit("setSyncStatusText", data.sync_status.text);
            commit("setSyncStatusmsg", data.message);
            commit("setSyncStatusStage", "processing");
          } else if (id == 2) {
            // '2'=>'Validating',
            setTimeout(() => {
              dispatch("fetchSyncUsersJobStatus", payload);
            }, 1000);
            commit("setMigrateStatusText", data.sync_status.text);
            commit("setMigrateStatusmsg", data.message);
            commit("setMigrateStatusStage", "processing");
            commit("setSyncStatusText", data.sync_status.text);
            commit("setSyncStatusmsg", data.message);
            commit("setSyncStatusStage", "processing");
          } else if (id == 3 || id == 15) {
            console.log('3 state', store.getters["integration/getIntgData"]);
            // '3'=>'Done',
            commit("setLoadingSync", false);
            commit("setMigrateStatusText", data.sync_status.text);
            commit("setMigrateStatusmsg", data.message);
            commit("setMigrateStatusStage", "done");
            commit("setSyncStatusText", data.sync_status.text);
            commit("setSyncStatusmsg", data.message);
            commit("setSyncStatusStage", "done");
            router.push("/view-integration/" + payload + "/" + store.getters["integration/getIntgData"].name);
          } else if (id == 4) {
            // '4'=>'Importing Faild',
            commit("setLoadingSync", false);
            commit("setMigrateStatusText", data.sync_status.text);
            commit("setMigrateStatusmsg", 'Retry');
            commit("setMigrateStatusStage", "failed");
            commit("setSyncStatusText", data.sync_status.text);
            commit("setSyncStatusmsg", 'Retry');
            commit("setSyncStatusStage", "failed");
          } else if (id == 5) {
            // '5'=>'Failed'
            commit("setLoadingSync", false);
            commit("setMigrateStatusText", data.sync_status.text);
            commit("setMigrateStatusmsg", 'Retry');
            commit("setMigrateStatusStage", "failed");
            commit("setSyncStatusText", data.sync_status.text);
            commit("setSyncStatusmsg", 'Retry');
            commit("setSyncStatusStage", "failed");
          } else if (id == 6) {
            // '6'=>'Syncing',
            setTimeout(() => {
              dispatch("fetchSyncUsersJobStatus", payload);
            }, 3000);
            commit("setMigrateStatusText", data.sync_status.text);
            commit("setMigrateStatusmsg", data.message);
            commit("setMigrateStatusStage", "processing");
            commit("setSyncStatusText", data.sync_status.text);
            commit("setSyncStatusmsg", data.message);
            commit("setSyncStatusStage", "processing");
          } else if (id == 9) {
            // '7'=>'Authentication Failed'
            dispatch("getIntegration", {
              id: payload.id
            });
            commit("setLoadingSync", false);
            commit("setMigrateStatusText", data.sync_status.text);
            commit("setMigrateStatusmsg", 'Click on the "Back" button for re-authenticate');
            commit("setMigrateStatusStage", "auth-failed");
            commit("setSyncStatusText", data.sync_status.text);
            commit("setSyncStatusmsg", 'Click on the "Back" button for re-authenticate');
            commit("setSyncStatusStage", "auth-failed");
            // router.push("/view-integration/" + payload.id + "/" + payload.name);
          } else if (id == 10) {
            // '10'=>'Invalid'
            dispatch("getIntegration", {
              id: payload.id
            });
            commit("setLoadingSync", false);
            commit("setMigrateStatusText", data.sync_status.text);
            commit("setMigrateStatusmsg", data.message);
            commit("setMigrateStatusStage", "auth-failed");
            commit("setSyncStatusText", data.sync_status.text);
            commit("setSyncStatusmsg", data.message);
            commit("setSyncStatusStage", "auth-failed");
          } else {
            // '7'=>'Failed'
            commit("setLoadingSync", false);
            commit("setMigrateStatusText", data.sync_status.text);
            commit("setMigrateStatusmsg", 'Retry');
            commit("setMigrateStatusStage", "failed");
            commit("setSyncStatusText", data.sync_status.text);
            commit("setSyncStatusmsg", 'Retry');
            commit("setSyncStatusStage", "failed");
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getSyncLogsList({
    commit,
    dispatch
  }, payload) {
    return new Promise((resolve, reject) => {
      integrationService
        .getSyncLogsList(payload)
        .then((data) => {
          resolve(data);
          commit("setSyncLogs", data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  
  getSyncAttendanceCodesList({
    commit,
    dispatch
  }, int_id) {
    return new Promise((resolve, reject) => {
      integrationService
        .getSyncAttendanceCodesService(int_id)
        .then((data) => {
          resolve(data);
          console.log("%c----< Attendance data >-----", "background-color:black;color:white; font-size:14px");
          // console.log(data);
          // commit("setSyncAttendanceCodes", data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  editTerminology({commit}, payload) {
    return new Promise((resolve, reject) => {
      integrationService
        .editTerminology(payload)
        .then((data) => {
          resolve(data);
          this._vm.$toast.success("Saved Successfully");
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  setFromView({
    commit
  }, payload) {
    // commit("setLoading", false);
    console.log('setfromview', payload);
    commit("setFromView", payload);
  },

  resetNoGroups({
    commit
  }, payload) {
    commit("setNoGroups", payload)
  },

  setWondeHaveTokenValue({
    commit
  }, haveTokenValue) {
    commit("setWondeHaveTokenValue", haveTokenValue)
  },

  preRequest({
    commit, dispatch
  }, payload) {
    return new Promise((resolve, reject) => {
      integrationService
        .preRequest(payload)
        .then((data) => {
          resolve(data);
          dispatch('fetchGridIntegrationData')
        })
        .catch((err) => {
          reject(err);
          commit("setResponseErrors", err.data.error);
        });
    });
  },

  setIsExtraScenario({commit}, payload){
    commit('setIsExtraScenario', payload)
  },

  fetchDirAreas({ commit }, payload) {
    return new Promise((resolve, reject) => {
      integrationService
        .getAreas(payload.code, payload.data)
        .then((data) => {
          resolve(data);
          console.log('fetchdirareas', data.areas);
          commit('setDirAreas', data.areas);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getUserTypes({ commit }, payload) {
    return new Promise((resolve, reject) => {
      integrationService
        .getUserTypes(payload)
        .then((data) => {
          resolve(data);
          console.log('getUserTypes', data);
          commit('setRoles', data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  findIntegration({ commit }, payload) {
    return new Promise((resolve, reject) => {
      integrationService
        .findIntegration(payload)
        .then((data) => {
          resolve(data);
          console.log('setIntgName', data);
          commit('setIntgName', data.name);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  
  fetchWondeIntegrations({ commit }) {
    return new Promise((resolve, reject) => {
      integrationService
        .getWondeIntegrations()
        .then((data) => {
          resolve(data);
          commit("setWondeIntegrations", data);
        })
        .catch((err) => {
            reject(err);
            this._vm.$toast.error(err.data.message ? err.data.message : err.data.message);
        });
    });
},

refreshMapping({ commit }, payload) {
  return new Promise((resolve, reject) => {
    integrationService
      .refreshMapping(payload)
      .then((data) => {
        resolve(data);
        // commit("setWondeIntegrations", data);
        console.log('refreshMapping', data);
      })
      .catch((err) => {
          reject(err);
          this._vm.$toast.error(err.data.message ? err.data.message : err.data.message);
      });
  });
},

fetchIntegrationAttendanceCodes({ commit }, payload) {
  return new Promise((resolve, reject) => {
    integrationService
      .fetchIntegrationAttendanceCodes(payload)
      .then((data) => {
        resolve(data);
        console.log('fetchIntegrationAttendanceCodes', data);
        commit("setIntegrationAttendanceCodes", data.data);
      })
      .catch((err) => {
          reject(err);
          this._vm.$toast.error(err.data.message ? err.data.message : err.data.message);
      });
  });
},

fetchIntegrationScans({ commit }, payload) {
  return new Promise((resolve, reject) => {
    integrationService
      .fetchIntegrationScans(payload)
      .then((data) => {
        resolve(data);
        console.log('getIntegrationScans', data);
        commit("setIntegrationScans", data.data);
      })
      .catch((err) => {
          reject(err);
          this._vm.$toast.error(err.data.message ? err.data.message : err.data.message);
      });
  });
},

syncIntegrationScans({ dispatch }, payload) {
  return new Promise((resolve, reject) => {
    integrationService
      .syncIntegrationScans(payload)
      .then((data) => {
        resolve(data);
        dispatch("fetchIntegrationScans", payload.intgId);
        console.log('syncIntegrationScans', data);
      })
      .catch((err) => {
          reject(err);
          this._vm.$toast.error(err.data.message ? err.data.message : err.data.message);
      });
  });
},

ignoreIntegrationScans({ dispatch }, payload) {
  return new Promise((resolve, reject) => {
    integrationService
      .ignoreIntegrationScans(payload)
      .then((data) => {
        resolve(data);
        dispatch("fetchIntegrationScans", payload.intgId);
        console.log('ignoreIntegrationScans', payload);
      })
      .catch((err) => {
          reject(err);
          this._vm.$toast.error(err.data.message ? err.data.message : err.data.message);
      });
  });
},

editIntegrationScans({ dispatch }, payload) {
  const obj = {
    ids: payload.ids,
    attendanceCodeId: payload.attendanceCodeId
  }
  return new Promise((resolve, reject) => {
    integrationService
      .editIntegrationScans(obj)
      .then((data) => {
        resolve(data);
        dispatch("fetchIntegrationScans", payload.integId);
        console.log('editIntegrationScans', data);
      })
      .catch((err) => {
          reject(err);
          this._vm.$toast.error(err.data.message ? err.data.message : err.data.message);
      });
  });
},
};

export const mutations = {
  setErrMsg(state, payload) {
    state.errMsg = payload;
  },
  setLoading(state, payload) {
    state.loading = payload;
  },
  setSyncDestroyed(state, payload) {
    state.syncDestroyed = payload;
  },
  setNoGroups(state, payload) {
    state.noGroups = payload;
  },
  setDirectoryList(state, payload) {
    state.directoryList = payload;
  },
  setGridData(state, payload) {
    state.gridIntegrationData = payload;
  },
  setcreatedIntegration(state, payload) {
    state.createIntegration = payload;
  },
  setIntgData(state, payload) {
    state.intgData = payload;
  },
  setIntgDataMapping(state, payload) {
    state.intgDataMapping = payload;
  },
  setIntgStatus(state, payload) {
    state.intgStatus = payload;
  },
  setResponseErrors(state, payload) {
    state.responseErrors = payload;
  },
  setConfigData(state, payload) {
    state.directoryConfigData = payload;
  },
  setIntegId(state, payload) {
    state.createdIntgId = payload;
  },
  setLoadingSync(state, payload) {
    state.syncLoading = payload;
  },
  setSyncStatusText(state, payload) {
    state.syncTextMessage = payload;
  },
  setSyncStatusmsg(state, payload) {
    state.syncTextFullMessage = payload;
  },
  setSyncStatusStage(state, payload) {
    state.syncStatus = payload;
  },
  setSyncedUsers(state, payload) {
    state.syncedUsers = payload;
  },
  setValidUsers(state, payload) {
    state.validUsers = payload;
  },
  setSyncedUsersCount(state, payload) {
    state.syncedUsersCount = payload;
  },
  setValidUsersCount(state, payload) {
    state.validUsersCount = payload;
  },
  setUsersWithErrs(state, payload) {
    state.usersWithErrs = payload;
  },
  setUsersWithErrsCount(state, payload) {
    state.usersWithErrsCount = payload;
  },
  setUsersWithDuplicates(state, payload) {
    state.usersWithDuplicates = payload;
  },
  setUsersWithDuplicatesCount(state, payload) {
    state.usersWithDuplicatesCount = payload;
  },
  setMigrateStatusText(state, payload) {
    state.migrateTextMessage = payload;
  },
  setMigrateStatusmsg(state, payload) {
    state.migrateTextFullMessage = payload;
  },
  setMigrateStatusStage(state, payload) {
    state.migrateStatus = payload;
  },

  setModalState(state, payload) {
    state.modalState = payload;
  },

  setReAuth(state, payload) {
    state.isReAuth = payload;
  },

  setSyncLogs(state, payload) {
    state.syncLogs = payload;
  },
 
  setSyncAttendanceCodes(state, payload) {
  state.syncAttendanceCodes = payload;
 },
  setFromView(state, payload) {
    state.isFromView = payload;
  },

  setSyncId(state, payload) {
    state.syncId = payload;
  },

  setIsEdit(state, payload) {
    state.isEditMode = payload;
  },

  setFromBack(state, payload) {
    state.isFromBack = payload;
  },

  setIntegrationUsersTypes(state, payload) {
    state.integrationUserTypes = payload;
  },

  setDecryptedEmail(state, payload) {
    state.decryptedEmail = payload;
  },

  setWondeHaveTokenValue(state, payload) {
    state.wondeHaveTokenValue = payload;
  },

  setSelectedSiteAreas(state, payload) {
    state.siteAreas = payload
  },

  setIsExtraScenario(state, payload) {
    state.isExtraScenario = payload
  },

  setDirAreas(state, payload) {
    state.dirAreas = payload;
  },

  setRoles(state, payload) {
    state.roles = payload;
  },

  setIntgName(state, payload) {
    state.intgName = payload;
  },
  
  setWondeIntegrations(state, payload) {
    state.wondeIntegrations = payload;
  },

  setIntegrationScans(state, payload) {
    state.integrationScans = payload;
  },

  setIntegrationAttendanceCodes(state, payload) {
    state.integrationAttendanceCodes = payload;
  },
};

export const getters = {
  getErrMsg(state) {
    return state.errMsg;
  },
  getLoading(state) {
    return state.loading;
  },
  getSyncDestroyed(state) {
    return state.syncDestroyed;
  },
  getNoGroups(state) {
    return state.noGroups;
  },
  getDirectoryList(state) {
    return state.directoryList;
  },
  getGridIntegrationData(state) {
    return state.gridIntegrationData;
  },
  getCreatedIntegration(state) {
    return state.createIntegration;
  },
  getIntgData(state) {
    return state.intgData;
  },
  getIntgDataMapping(state) {
    return state.intgDataMapping;
  },
  getIntgStatus(state) {
    return state.intgStatus;
  },
  getResponseErrors(state) {
    return state.responseErrors;
  },
  getConfigData(state) {
    return state.directoryConfigData;
  },
  getIntegId(state) {
    return state.createdIntgId;
  },
  getLoadingSync(state) {
    return state.syncLoading;
  },
  getSyncStatusText(state) {
    return state.syncTextMessage;
  },
  getSyncStatusmsg(state) {
    return state.syncTextFullMessage
  },
  getSyncStatusStage(state) {
    return state.syncStatus;
  },
  getSyncedUsers(state) {
    return state.syncedUsers;
  },
  getSyncedUsersCount(state) {
    return state.syncedUsersCount;
  },
  getValidUsers(state) {
    return state.validUsers;
  },
  getValidUsersCount(state) {
    return state.validUsersCount;
  },
  getUsersWithErrs(state) {
    return state.usersWithErrs;
  },
  getUsersWithErrsCount(state) {
    return state.usersWithErrsCount;
  },
  getUsersWithDuplicates(state) {
    return state.usersWithDuplicates;
  },
  getUsersWithDuplicatesCount(state) {
    return state.usersWithDuplicatesCount;
  },
  getMigrateStatusText(state) {
    return state.migrateTextMessage;
  },
  getMigrateStatusmsg(state) {
    return state.migrateTextFullMessage;
  },
  getMigrateStatusStage(state) {
    return state.migrateStatus;
  },

  getModalState(state) {
    return state.modalState;
  },

  getReAuth(state) {
    return state.isReAuth;
  },

  getSyncLogs(state) {
    return state.syncLogs;
  },
  
  getSyncAttendanceCodes(state) {
    return state.syncAttendanceCodes;
  },
  getFromView(state) {
    return state.isFromView;
  },

  getSyncId(state) {
    return state.syncId;
  },

  getIsEdit(state) {
    return state.isEditMode;
  },

  getFromBack(state) {
    return state.isFromBack;
  },

  getIntegrationUsersTypes(state) {
    return state.integrationUserTypes;
  },

  getDecryptedEmail(state) {
    return state.decryptedEmail;
  },
  getWondeHaveTokenValue(state) {
    return state.wondeHaveTokenValue
  },
  getSelectedSitesAreas(state) {
    return state.siteAreas;
  },
  getIsExtraScenario(state) {
    return state.isExtraScenario
  },
  getDirAreas(state) {
    return state.dirAreas;
  },

  getRoles(state) {
    return state.roles;
  },
  getIntgName(state) {
    return state.intgName;
  },
  
  getWondeIntegrations(state) {
    return state.wondeIntegrations;
  },

  getIntegrationScans(state) {
    return state.integrationScans;
  },

  getIntegrationAttendanceCodes(state) {
    return state.integrationAttendanceCodes;
  },

};